const NAMESPACE = "paymentHistoryDetail";

const KEYS = {
    currentStatus: "currentStatus",
    changedBy: "changedBy",
    failureReason: "failureReason",
    externalId: "externalId",
    noExternalId: "noExternalId",
    savedMetadata: "savedMetadata",
    noMetadata: "noMetadata",
    paymentStatusHistory: "paymentStatusHistory",
    noPaymentHistory: "noPaymentHistory",
    statusColumn: "statusColumn",
    dateColumn: "dateColumn",
    changedByColumn: "changedByColumn",
    nameColumn: "nameColumn",
    valueColumn: "valueColumn"
};

const MESSAGES = {
    [KEYS.currentStatus]: {
        value: "Current Status:",
        comment: "Label for field showing current status of payment"
    },
    [KEYS.failureReason]: {
        value: "Reason: ",
        comment: "Label for field showing reason for a payment failure"
    },
    [KEYS.changedBy]: {
        value: "Changed by: ",
        comment: "label for field indicating which user changed the payment to its current status"
    },
    [KEYS.externalId]: {
        value: "External ID: ",
        comment: "Label for field showing external ID (if exists)"
    },
    [KEYS.noExternalId]: {
        value: "No external ID",
        comment: "Text value to display in External Id field if external id not available"
    },
    [KEYS.savedMetadata]: {
        value: "Saved Metadata",
        comment: "Title for section showing saved metadata for payment"
    },
    [KEYS.noMetadata]: {
        value: "No metadata",
        comment: "Message to display if no data in saved metadata section"
    },
    [KEYS.paymentStatusHistory]: {
        value: "Payment Status History",
        comment: "Title for section showing status history for payment"
    },
    [KEYS.noPaymentHistory]: {
        value: "No payment history",
        comment: "Message to display in payment status history section if no payment history exists"
    },
    [KEYS.statusColumn]: {
        value: "Status",
        comment: "Header for the  column in the status history table"
    },
    [KEYS.dateColumn]: {
        value: "Date",
        comment: "Header for the  column in the status history table"
    },
    [KEYS.changedByColumn]: {
        value: "Changed By",
        comment: "Header for the  column in the status history table"
    },
    [KEYS.nameColumn]: {
        value: "Name",
        comment: "Header for the  column in the saved metadata table"
    },
    [KEYS.valueColumn]: {
        value: "Value",
        comment: "Header for the  column in the daved metadata table"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
